<mat-toolbar class="mat-primary">
  <span class="fill-remaining-space">Personalisierung anpassen</span>
  <mat-icon class="cursor-mat-element" (click)="onCancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <ng-container *ngIf="permissions$ | async as permissions">
    <ng-container *ngIf="pageConfigsForm$ | async as pageConfigsForm">
      <form [formGroup]="pageConfigsForm">
        <h2>Seitenkonfigurationen</h2>
        <mat-checkbox
          [(ngModel)]="allPagesV2Selected"
          [checked]="isAllPagesV2Selected$(pageConfigsForm) | async"
          (change)="onToggleAllPages($event.checked, pageConfigsForm)">
          Neue Listen für
          <strong>alle Seiten</strong>
          verwenden
        </mat-checkbox>
        <div style="margin-left: 2rem">
          <app-string-checkbox
            *ngIf="permissions.orderRequest"
            [formControl]="pageConfigsForm.controls['order-request'].controls.pageVersion"
            [trueValue]="'v2'"
            [falseValue]="'v1'">
            Neue Liste für
            <strong>Hausanschlüsse</strong>
            verwenden
          </app-string-checkbox>
          <app-string-checkbox
            *ngIf="permissions.installerPass"
            [formControl]="pageConfigsForm.controls['admin-installer-pass'].controls.pageVersion"
            [trueValue]="'v2'"
            [falseValue]="'v1'">
            Neue Liste für
            <strong>Ausweise</strong>
            verwenden
          </app-string-checkbox>
          <app-string-checkbox
            *ngIf="permissions.installer || permissions.commissioning"
            [formControl]="pageConfigsForm.controls['commissioning-request'].controls.pageVersion"
            [trueValue]="'v2'"
            [falseValue]="'v1'">
            Neue Liste für
            <strong>Inbetriebnahmen</strong>
            verwenden
          </app-string-checkbox>
          <app-string-checkbox
            *ngIf="permissions.installer || permissions.gridRegistration"
            [formControl]="pageConfigsForm.controls['grid-registration'].controls.pageVersion"
            [trueValue]="'v2'"
            [falseValue]="'v1'">
            Neue Liste für
            <strong>Netzanmeldungen</strong>
            verwenden
          </app-string-checkbox>
          <app-string-checkbox
            *ngIf="permissions.feederContract"
            [formControl]="pageConfigsForm.controls['feeder-contract'].controls.pageVersion"
            [trueValue]="'v2'"
            [falseValue]="'v1'">
            Neue Liste für
            <strong>Einspeiserverträge</strong>
            verwenden
          </app-string-checkbox>
        </div>
      </form>
      <div class="button-container">
        <button mat-stroked-button color="primary" (click)="onCancel()">Abbrechen</button>
        <button mat-raised-button (click)="onConfirm(pageConfigsForm)" color="primary">Speichern</button>
      </div>
    </ng-container>
  </ng-container>
</mat-dialog-content>
